// extracted by mini-css-extract-plugin
export default {"client-profile-content":"client-profile-page_client-profile-content__Nes79"};